module.exports = __webpack_public_path__ + "img/back-to-top.41e18713.svg";